// import React, { useEffect, useState } from 'react';
// import axios from 'axios';

// //styles
// import styles from './Verify.module.scss';
// import './multiStyles.css';

// //functions
// import { extractQueryParameters } from '../functions/queryStrings';
// import { notify } from '../functions/hotToast';

// //shared
// import Loading from '../shared/Loading';

// const Verify = () => {
//   const querys = extractQueryParameters(window.location.href);
//   console.log({querys});
  
//   ///check gateway type
//   const getGatewayType = () => {
//     if (querys.Token) {
//       return 'PARSIAN'; 
//     } else if (querys.Authority) {
//       return 'ZARINPAL'; 
//     }
//     return null;
//   };
//   const gatewayType = getGatewayType();
//   ///

//   let chekcQuerys = true;


//   if ((!querys.Authority && !querys.Token) || !querys.Status) chekcQuerys = false;
//   let checkStatus = querys.Status === (gatewayType==="PARSIAN"?"0":'OK') ? true : false;

//   const [isLoad, setIsLoad] = useState(true);
//   const [okOrNot, setOkOrNot] = useState(false);
//   const [disableBtnRecheck, setDisableBtnRecheck] = useState(false);

//   const [messageShow, setMessageShow] = useState('');

//   const reCheck = () => {
//     if (chekcQuerys) {
//       setDisableBtnRecheck(true);

//       if (checkStatus) {
//         const baseUrl = process.env.REACT_APP_API_BASE_URL;

//         const bodySend = {
//           authority:(gatewayType==="PARSIAN" ? querys.Token :  querys.Authority),
//           query: querys,
//         };

//         axios
//           .post(`${baseUrl}api/pay/pay-verify`, bodySend)
//           .then((res) => {
//             if (res.data.status) {
//               const data = res.data.data;

//               setMessageShow(
//                 `پرداخت شما با شماره پیگیری ${data.ref_id} با موفقیت انجام شد`
//               );
//               setOkOrNot(true);
//             } else {
//               setMessageShow('پرداخت شما به درستی تایید نشده است');
//               setOkOrNot(false);
//             }

//             setIsLoad(false);
//             setDisableBtnRecheck(false);
//           })
//           .catch((error) => {
//             notify(
//               'مشکل در نمایش اطلاعات دریافتی از درگاه',
//               'error',
//               2000
//             );
//             setMessageShow('مشکل در نمایش اطلاعات دریافتی از درگاه');
//             console.log(error);
//             setIsLoad(false);
//             setDisableBtnRecheck(false);
//           });
//       } else {
//         setIsLoad(false);
//         setMessageShow('پرداخت شما با مشکل مواجه شد');
//         setDisableBtnRecheck(false);
//       }
//     }
//   };

//   useEffect(() => {
//     reCheck();
//   }, []);

//   const backBtn = () => {
//     window.history.pushState({}, '', `/`);
//     window.location.reload();
//   };

//   if (!chekcQuerys) return alert('لینک ورودی به این صفحه صحیح نیست');

//   return !isLoad ? (
//     <>
//       <div className="mainContainer container">
//         <div
//           className="childContainer container-fluid"
//           style={{
//             backgroundColor: okOrNot ? '#069e15' : '#d21404',
//             color: '#fff',
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: 'center',
//             justifyContent: 'center',
//             height: 'fit-content',
//             padding: '2.5rem 2rem',
//             textAlign: 'justify',
//             lineHeight: '2.2rem',
//           }}
//         >
//           {okOrNot ? (
//             <svg
//               className={styles.icon}
//               xmlns="http://www.w3.org/2000/svg"
//               fill="#fff"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 fillRule="evenodd"
//                 d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 100 16 8 8 0 000-16zm3.293 4.293L10 13.586l-1.293-1.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l6-6a1 1 0 10-1.414-1.414z"
//               ></path>
//             </svg>
//           ) : (
//             <svg
//               className={styles.icon}
//               xmlns="http://www.w3.org/2000/svg"
//               fill="none"
//               viewBox="0 0 24 24"
//             >
//               <g>
//                 <g>
//                   <path
//                     stroke="#fff"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth="2"
//                     d="M9 9l3 3m0 0l3 3m-3-3l-3 3m3-3l3-3m-3 12a9 9 0 110-18 9 9 0 010 18z"
//                   ></path>
//                 </g>
//               </g>
//             </svg>
//           )}

//           <span
//             style={{
//               color: '#fff',
//               fontSize: '1.2rem',
//               textAlign: 'center',
//             }}
//           >
//             {messageShow}
//           </span>

//           <button
//             onClick={!okOrNot ? reCheck : backBtn}
//             className="mt-4"
//             disabled={disableBtnRecheck}
//           >
//             {!okOrNot ? (
//               <>
//                 بررسی مجدد
//                 {disableBtnRecheck && (
//                   <span
//                     class="spinner-border spinner-border-sm me-2"
//                     aria-hidden="true"
//                   ></span>
//                 )}
//               </>
//             ) : (
//               'بازگشت'
//             )}
//           </button>
//         </div>

//         <div className="circle1"></div>
//         <div className="circle2"></div>
//       </div>
//     </>
//   ) : (
//     <Loading />
//   );
// };

// export default Verify;
import React, { use, useEffect, useState } from 'react';

//styles
import styles from './Verify.module.scss';
import './multiStyles.css';

//functions
import { extractQueryParameters } from '../functions/queryStrings';


const Verify = () => {
  const querys = extractQueryParameters(window.location.href);
  console.log({querys});

  const [messageShow, setMessageShow] = useState('');

  useEffect(() => {
      if(querys.ref_id){
        setOkOrNot(true);
        setMessageShow(decodeURIComponent("پرداخت با موفقیت دریافت شد."))
      }else{
        setOkOrNot(false);
        setMessageShow(decodeURIComponent(querys.message))
      }
  }, [])
  





  // const [isLoad, setIsLoad] = useState(true);
  const [okOrNot, setOkOrNot] = useState(false);
  const [disableBtnRecheck, setDisableBtnRecheck] = useState(false);

  

  const backBtn = () => {
    window.history.pushState({}, '', `/`);
    window.location.reload();
  };


  return(
    <>
 
      <div className="mainContainer container">
        <div
          className="childContainer container-fluid"
          style={{
            backgroundColor: okOrNot ? '#069e15' : '#d21404',
            color: '#fff',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: 'fit-content',
            padding: '2.5rem 2rem',
            textAlign: 'justify',
            lineHeight: '2.2rem',
          }}
        >
          {okOrNot ? (
            <svg
              className={styles.icon}
              xmlns="http://www.w3.org/2000/svg"
              fill="#fff"
              viewBox="0 0 24 24"
            >
              <path
                fillRule="evenodd"
                d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 100 16 8 8 0 000-16zm3.293 4.293L10 13.586l-1.293-1.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l6-6a1 1 0 10-1.414-1.414z"
              ></path>
            </svg>
          ) : (
            <svg
              className={styles.icon}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <g>
                <g>
                  <path
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 9l3 3m0 0l3 3m-3-3l-3 3m3-3l3-3m-3 12a9 9 0 110-18 9 9 0 010 18z"
                  ></path>
                </g>
              </g>
            </svg>
          )}

          <span
            style={{
              color: '#fff',
              fontSize: '1.2rem',
              textAlign: 'center',
            }}
          >
            {messageShow}
          </span>

          <button
            onClick={!okOrNot ? backBtn : backBtn}
            className="mt-4"
            disabled={disableBtnRecheck}
          >
            {!okOrNot ? (
              <>
                بررسی مجدد
                {disableBtnRecheck && (
                  <span
                    class="spinner-border spinner-border-sm me-2"
                    aria-hidden="true"
                  ></span>
                )}
              </>
            ) : (
              'بازگشت'
            )}
          </button>
        </div>

        <div className="circle1"></div>
        <div className="circle2"></div>
      </div>
    </> )
};

export default Verify;
